import { render, staticRenderFns } from "./ProjectProfileForm.vue?vue&type=template&id=7287b529&scoped=true&"
import script from "./ProjectProfileForm.vue?vue&type=script&lang=js&"
export * from "./ProjectProfileForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7287b529",
  null
  
)

export default component.exports